module.exports = __webpack_public_path__ + "img/couples_07_V.b227ba3a.webp";